var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 26,
    viewBox: "0 0 80 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.2109 4.57892C76.2109 3.64876 76.965 2.89471 77.8951 2.89471V9.63156H76.2109V4.57892Z",
    fill: "#827677"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8359 11.3916C69.8359 10.4661 70.5862 9.71585 71.5117 9.71585V16.4527H69.8359V11.3916Z",
    fill: "#827677"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.666 22.263V19.5279L23.5953 19.0799V14.5056C23.5953 13.4524 23.2966 12.6428 22.6993 12.0769C22.1177 11.511 21.2452 11.2281 20.082 11.2281C19.2804 11.2281 18.518 11.3617 17.7949 11.6289C17.5778 11.7092 17.3707 11.7971 17.1735 11.8929C16.4887 12.2255 15.5947 12.092 15.2012 11.4403C15.83 10.9059 16.5845 10.4972 17.4648 10.2142C18.345 9.91554 19.2725 9.7662 20.2471 9.7662C21.8505 9.7662 23.0844 10.167 23.949 10.9687C24.8292 11.7547 25.2694 12.9572 25.2694 14.5763V22.263H23.666ZM19.3983 22.3809C18.4708 22.3809 17.6612 22.2316 16.9696 21.9329C16.2937 21.6186 15.7749 21.1942 15.4134 20.6597C15.0519 20.1095 14.8711 19.4807 14.8711 18.7734C14.8711 18.1289 15.0204 17.5473 15.3191 17.0285C15.6335 16.494 16.1365 16.0696 16.8281 15.7553C17.5355 15.4252 18.4787 15.2601 19.6576 15.2601H23.9254V16.5098H19.7048C18.5101 16.5098 17.677 16.722 17.2054 17.1464C16.7496 17.5708 16.5216 18.0974 16.5216 18.7262C16.5216 19.4336 16.7967 19.9995 17.3469 20.4239C17.897 20.8483 18.6673 21.0605 19.6576 21.0605C20.6008 21.0605 21.4103 20.8483 22.0863 20.4239C22.7779 19.9837 23.2809 19.355 23.5953 18.5376L23.9726 19.6929C23.6582 20.5104 23.108 21.1627 22.322 21.65C21.5518 22.1373 20.5772 22.3809 19.3983 22.3809Z",
    fill: "#827677"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2109 9.63156V23.1052H77.8951V9.63156H76.2109Z",
    fill: "#827677"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43234 13.751H12.9679V15.2601H4.43234V20.5182C4.43234 21.4819 3.65115 22.263 2.6875 22.263V5.75778H14.0054V7.26683H4.43234V13.751Z",
    fill: "#827677"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8905 22.381C31.7273 22.381 30.8313 22.0667 30.2025 21.4379C29.5737 20.8091 29.2594 19.921 29.2594 18.7734V11.2753H27.043V9.88418H29.2594V7.14902C30.184 7.14902 30.9335 7.89854 30.9335 8.82312V9.88418H34.7061V11.2753H30.9335V18.6791C30.9335 19.4022 31.1143 19.9602 31.4758 20.3532C31.8531 20.7462 32.3876 20.9427 33.0792 20.9427C33.818 20.9427 34.431 20.7305 34.9183 20.3061L35.5078 21.5086C35.1777 21.8073 34.7769 22.0273 34.3053 22.1688C33.8495 22.3103 33.3779 22.381 32.8905 22.381Z",
    fill: "#827677"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6266 22.2631V11.2753H50.4102V9.88416H52.6266V8.32794C52.6266 7.22759 52.9488 6.33946 53.5933 5.66352C54.2379 4.98759 55.1653 4.64963 56.3756 4.64963C56.8472 4.64963 57.3031 4.71251 57.7432 4.83826C58.1834 4.96401 58.5528 5.16051 58.8514 5.42773L58.2855 6.67742C58.0497 6.47306 57.7747 6.32373 57.4603 6.22942C57.1459 6.11938 56.808 6.06437 56.4464 6.06437C55.739 6.06437 55.1967 6.26085 54.8194 6.65384C54.4422 7.04682 54.2535 7.62843 54.2535 8.39868V9.88416H58.0733C58.0733 10.6525 57.4505 11.2753 56.6822 11.2753H54.3007V22.2631H52.6266Z",
    fill: "#827677"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4533 22.3811C64.4001 22.3811 63.4805 22.1846 62.6945 21.7916C61.9086 21.3986 61.2955 20.8091 60.8554 20.0232C60.431 19.2372 60.2188 18.2547 60.2188 17.0758V9.88422H61.8929V16.8872C61.8929 18.2076 62.2151 19.2057 62.8596 19.8817C63.5198 20.5419 64.4394 20.872 65.6183 20.872C66.4829 20.872 67.2295 20.6991 67.8583 20.3533C68.5028 19.9918 68.9901 19.473 69.3202 18.7971C69.6661 18.1211 69.839 17.3116 69.839 16.3684V11.5583C69.839 10.6337 70.5885 9.88422 71.5131 9.88422V22.2632H69.9097V19.9994C69.5246 20.6681 68.998 21.2105 68.3299 21.6265C67.5125 22.1295 66.5537 22.3811 65.4533 22.3811Z",
    fill: "#827677"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5625 22.2463C42.2735 22.2463 41.1417 21.9791 40.1671 21.4446C39.1925 20.8945 38.4301 20.1478 37.88 19.2046C37.3297 18.2457 37.0547 17.1532 37.0547 15.9271C37.0547 14.701 37.3141 13.6164 37.8328 12.6732C38.3672 11.7301 39.0903 10.9913 40.0021 10.4568C40.9295 9.90665 41.9669 9.63156 43.1145 9.63156C44.2777 9.63156 45.3073 9.89879 46.2033 10.4332C47.115 10.952 47.8303 11.6908 48.349 12.6497C48.8677 13.5928 49.1271 14.6853 49.1271 15.9271C49.1271 16.0057 49.1192 16.0922 49.1035 16.1865C49.1035 16.2651 49.1035 16.3516 49.1035 16.4459H38.328V15.1962H48.2075L47.5473 15.6914C47.5473 14.7954 47.3508 14.0015 46.9578 13.3099C46.5806 12.6025 46.0618 12.0523 45.4016 11.6594C44.7414 11.2664 43.979 11.0699 43.1145 11.0699C42.2656 11.0699 41.5032 11.2664 40.8273 11.6594C40.1514 12.0523 39.6248 12.6025 39.2475 13.3099C38.8703 14.0172 38.6816 14.8268 38.6816 15.7385V15.9979C38.6816 16.941 38.8859 17.7741 39.2947 18.4972C39.7191 19.2046 40.3007 19.7627 41.0395 20.1714C41.7941 20.5644 42.6507 20.7608 43.6096 20.7608C44.3642 20.7608 45.0636 20.6272 45.7082 20.36C45.9199 20.2743 46.1219 20.174 46.3143 20.0592C46.9646 19.671 47.852 19.6469 48.349 20.2185C47.7988 20.8787 47.1072 21.3817 46.2741 21.7276C45.4566 22.0734 44.5528 22.2463 43.5625 22.2463Z",
    fill: "#827677"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8359 11.3915C69.8359 10.466 70.5862 9.71576 71.5117 9.71576C71.5117 10.6413 70.7615 11.3915 69.8359 11.3915Z",
    fill: "url(#paint0_linear_7302_20826)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7578 11.2316C56.7578 10.4874 57.361 9.88419 58.1052 9.88419V9.92629C58.1052 10.6704 57.5019 11.2737 56.7578 11.2737V11.2316Z",
    fill: "url(#paint1_linear_7302_20826)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2739 20.0974C46.8799 19.5541 47.8116 19.6049 48.3549 20.2109C47.7489 20.7542 46.8172 20.7034 46.2739 20.0974Z",
    fill: "url(#paint2_linear_7302_20826)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.256 7.14079C30.1437 7.10799 30.8899 7.80101 30.9227 8.68871L30.9286 8.8486C30.0409 8.88141 29.2947 8.18839 29.2619 7.30069L29.256 7.14079Z",
    fill: "url(#paint3_linear_7302_20826)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4238 20.641C4.41842 21.5432 3.68265 22.2703 2.78041 22.2649L2.68778 22.2644C2.69315 21.3621 3.42893 20.6351 4.33117 20.6405L4.4238 20.641Z",
    fill: "url(#paint4_linear_7302_20826)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.786 12.0692C16.1751 12.3527 15.4514 12.0666 15.1994 11.4421L15.2464 11.4087C15.9497 10.9082 16.9252 11.0699 17.4295 11.7705L16.786 12.0692Z",
    fill: "url(#paint5_linear_7302_20826)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2109 4.57892C76.2109 3.64876 76.965 2.89471 77.8951 2.89471C77.8951 3.82488 77.1411 4.57892 76.2109 4.57892Z",
    fill: "url(#paint6_linear_7302_20826)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64 7.94735C64 5.15685 66.2621 2.89471 69.0526 2.89471H71.5789C71.5789 5.68521 69.3168 7.94735 66.5263 7.94735H64Z",
    fill: "url(#paint7_linear_7302_20826)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7302_20826",
    x1: 69.727,
    y1: 11.8943,
    x2: 72.0484,
    y2: 11.0869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7302_20826",
    x1: 56.6702,
    y1: 11.6905,
    x2: 58.5488,
    y2: 11.0569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7302_20826",
    x1: 45.8808,
    y1: 20.3213,
    x2: 47.7722,
    y2: 21.3672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7302_20826",
    x1: 28.7695,
    y1: 7.04375,
    x2: 29.7735,
    y2: 9.40396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7302_20826",
    x1: 4.53893,
    y1: 20.1516,
    x2: 2.17217,
    y2: 21.0055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7302_20826",
    x1: 17.9854,
    y1: 11.4815,
    x2: 16.0683,
    y2: 10.0434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7302_20826",
    x1: 76.1015,
    y1: 5.08419,
    x2: 78.4345,
    y2: 4.27273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7302_20826",
    x1: 63.5074,
    y1: 9.46314,
    x2: 72.7581,
    y2: 4.63685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.1846b0ccb54d0b0dcbddd9248e639f8d.svg";
export { ForwardRef as ReactComponent };